import { render } from "./DownloadField.vue?vue&type=template&id=5b4ed9d1"
import script from "./DownloadField.vue?vue&type=script&lang=js"
export * from "./DownloadField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__